import React from 'react';
import { useLocation } from 'react-router-dom';
import { Table } from './styles/ExpandedSearchResult-style';

const ExpandedSearchResult = ({ props }) => {
    const location = useLocation();
    const meetingDetails = location.state.item;
    console.log(meetingDetails);

    return (
        <div>
            <h2>Meeting Name: {meetingDetails.meetingName}</h2>
            <p>Meeting Owner: {meetingDetails.owner}</p>

            <Table>
                <thead>
                    <tr>
                        <th>Participant</th>
                        <th>Opinions</th>
                    </tr>
                </thead>
                <tbody>
                    {meetingDetails.opiniondict.map((participant, index) => (
                        <tr key={index}>
                            <td>{participant.name}</td>
                            <td>
                                <ul>
                                    {participant.opinions.map((opinion, index) => (
                                        <li key={index}>{opinion}</li>
                                    ))}
                                </ul>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <hr></hr>
            <Table>
                <thead>
                    <tr>
                        <th>Decisions</th>
                    </tr>
                </thead>
                <tbody>
                    {meetingDetails.decisionDict.map((decision, index) => (
                        <tr key={index}>
                            <td>
                                <ul>
                                    {decision}
                                </ul>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default ExpandedSearchResult;
